import { render, staticRenderFns } from "./KnGroupSchoolCycle.vue?vue&type=template&id=99c5fc28&"
import script from "./KnGroupSchoolCycle.vue?vue&type=script&lang=js&"
export * from "./KnGroupSchoolCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports